export default "__VITE_ASSET__DDvUdsam__"